import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';
import __vue_component__$1 from '../../../../../ui/Icon.vue.js';

var script = defineComponent({
    // @deprecated - use ItineraryWaypointConfirmDeparture instead
    name: 'ItineraryWaypointStartTransit',
    components: { ButtonComponent: __vue_component__, Icon: __vue_component__$1 },
    props: {
        waypointID: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const store = usePortalStore();
        const estimatedTransitDuration = computed(() => store.waypoints.getters.estimatedTransitDuration(props.waypointID));
        return {
            estimatedTransitDuration,
        };
    },
});

export { script as default };
